import { render, staticRenderFns } from "./Play.vue?vue&type=template&id=ba16c9f0"
import script from "./Play.vue?vue&type=script&lang=ts"
export * from "./Play.vue?vue&type=script&lang=ts"
import style0 from "./Play.vue?vue&type=style&index=0&id=ba16c9f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports